import EditIcon from '@mui/icons-material/Edit';
import { Box, Divider, Grid, Stack, styled } from '@mui/material';
import { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfiguredEmailContextType } from 'wisestep-api';
import { WsTypography, WsTypoVariants, WsTypoColors, WsButton, WsColors } from 'wisestep-base';

import { useEmailConfigurationContext } from '../../../../context';
const StyledBox = styled(Box)({
  borderRadius: 3,
  border: '1px solid' + WsColors.TheBlues200,
  cursor: 'pointer',
  backgroundColor: WsColors.White,
});
const SignatureContent = () => {
  const configuredContext = useEmailConfigurationContext();
  const [configuredEmails, setConfiguredEmail] = useState<ConfiguredEmailContextType[]>([]);
  const navigate = useNavigate();
  useEffect(() => {
    (async function () {
      if (configuredContext?.configuredData != null) {
        const dataReceived = configuredContext.configuredData;
        if (dataReceived.length > 0) {
          setConfiguredEmail(dataReceived);
        }
      }
    })();
  }, [configuredContext]);
  const configuredEmailsData = useMemo(
    () =>
      configuredEmails?.map((configuredEmailsList) => ({
        createdBy: configuredEmailsList.createdBy,
        createdOn: configuredEmailsList.createdOn,
        fromEmail: configuredEmailsList.fromEmail,
        fromName: configuredEmailsList.fromName,
        host: configuredEmailsList.host,
        isDefault: configuredEmailsList.isDefault,
        password: configuredEmailsList.password,
        port: configuredEmailsList.port,
        protection: configuredEmailsList.protection,
        recruiterId: configuredEmailsList.recruiterId,
        signatureName: configuredEmailsList.signatureName ?? '',
        signatureText: configuredEmailsList.signatureText ?? '',
        userName: configuredEmailsList.userName ?? '',
      })),
    [configuredEmails]
  );
  const handleCreateOrEditSignature = (variant: string, fromEmail?: string) => {
    if (variant === 'edit') {
      navigate('create', { state: { fromEmail: fromEmail } });
    } else {
      navigate('create');
    }
  };
  return (
    <Box>
      <Stack
        p={2}
        bgcolor={WsColors.TheBlues50}
        alignItems={'flex-start'}
        direction={'row'}
        justifyContent={'space-between'}
      >
        <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK}>
          Signature
        </WsTypography>
        <WsButton
          onClick={() => handleCreateOrEditSignature('create')}
          variant="contained"
          size="large"
        >
          Add/Edit Signature
        </WsButton>
      </Stack>
      {configuredEmailsData.map((lists) => (
        <Stack direction="column" spacing={2} key={lists.fromEmail}>
          <Grid marginTop={2} marginLeft={1} container>
            <Grid item xs={5.5}>
              <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
                {lists.fromEmail ?? ''}
              </WsTypography>
            </Grid>
            <Grid item xs={5.5}>
              <Stack direction={'row'}>
                <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
                  {lists.signatureName ?? ''}
                </WsTypography>
                <EditIcon
                  sx={{ cursor: 'pointer' }}
                  onClick={() => handleCreateOrEditSignature('edit', lists.fromEmail)}
                />
              </Stack>
            </Grid>
          </Grid>
          <StyledBox>
            <Grid item xs={10}>
              <div dangerouslySetInnerHTML={{ __html: lists.signatureText ?? 'NA' }} />
            </Grid>
          </StyledBox>
          <Divider orientation="horizontal" flexItem />
        </Stack>
      ))}
    </Box>
  );
};
export default SignatureContent;
